document.addEventListener('DOMContentLoaded', () => {
  console.log('sidebar-event-tracking.js loaded');
  const sidebarLinks = document.querySelectorAll('.SidebarMenuNav__Nav.parentNav a');

  if (!sidebarLinks.length) return;

  const pascalCase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const formatMenuDetails = (menuDetails) => {
    return {
      menuSelection: pascalCase(menuDetails.menuSelection),
      menuCategory: pascalCase(menuDetails.menuCategory),
      menuSubcategory: pascalCase(menuDetails.menuSubcategory),
    };
  };

  const getMenuDetails = (linkElement) => {
    let menuSelection = '';
    let menuCategory = '';
    let menuSubcategory = '';

    const parentNav = linkElement.closest('.SidebarMenuNav__Nav.parentNav');
    if (parentNav) {
      const navId = parentNav.getAttribute('data-nav');
      const topLevelButton = document.querySelector(
        `.SidebarMenuNav__Buttons .mobileNavBtn.topLevel[data-open="${navId}"]`,
      );
      menuSelection = topLevelButton?.textContent.trim() || navId || '';
    }

    const subNav = linkElement.closest('.SidebarMenuNav__SubNav');
    if (subNav) {
      menuCategory = (subNav.getAttribute('data-nav') || '').trim();
      menuSubcategory = linkElement.textContent.trim();
    }

    return formatMenuDetails({ menuSelection, menuCategory, menuSubcategory });
  };

  const handleLinkNavigation = (e) => {
    const link = e.currentTarget;
    const destination = link.getAttribute('href');

    // Skip tracking if there's no destination, it's an anchor link, or opens in a new tab
    if (!destination || destination.startsWith('#') || destination.startsWith('javascript:')) return;
    if (link.target === '_blank') return; // Allow default behavior for new tabs

    e.preventDefault();

    const { menuSelection, menuCategory, menuSubcategory } = getMenuDetails(link);

    // Push to DataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'menu_navigation',
      menu_selection: menuSelection,
      menu_category: menuCategory,
      menu_subcategory: menuSubcategory,
      click_url: new URL(destination, window.location.origin).href,
      eventCallback: () => {
        window.location.href = destination;
      },
    });

    // Safety Timeout: Fallback navigation in case GTM is blocked, fails to load, or is slow
    setTimeout(() => {
      window.location.href = destination;
    }, 1000);
  };

  sidebarLinks.forEach((link) => {
    link.addEventListener('click', handleLinkNavigation);
  });
});
